var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("footer", { staticClass: "vab-footer" }, [
    _c("div", { staticClass: "flex_space logo_box flex_center_align" }, [
      _c("img", {
        staticClass: "logo_img",
        attrs: { src: require("@/assets/images/logo.png") },
      }),
      _c("div", { staticClass: "flex_space" }, [
        _c(
          "div",
          {
            staticClass: "fot_word mg no_img flex_center_align",
            on: { click: _vm.goTom },
          },
          [
            _c("svg-icon", {
              staticClass: "fot_word_svg",
              attrs: { "icon-class": "tryangle_right1" },
            }),
            _c("span", [_vm._v("TOMOONI利用約款")]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "fot_word no_img flex_center_align",
            on: { click: _vm.goWorks },
          },
          [
            _c("svg-icon", {
              staticClass: "fot_word_svg",
              attrs: { "icon-class": "tryangle_right1" },
            }),
            _c("span", [_vm._v("Works特約")]),
          ],
          1
        ),
      ]),
    ]),
    _vm._m(0),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "flex_center flex_center_align bn_box" }, [
      _c("span", { staticClass: "bn" }, [
        _vm._v(" Copyright DAIWA LIFENEXT CO., LTD. All rights reserved. "),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }